import {selectFlat} from "@/data/select_flat.js";

export function selectEnvironmentSession() {
  return selectFlat("environmentSession");
}
